module.exports = __webpack_public_path__ + "img/product-thumb-up.7c851aa7.svg";